// extracted by mini-css-extract-plugin
module.exports = {"BlueContentList":"styles_BlueContentList__zCFxB","bg_1":"styles_bg_1__pF4Ol","bg_2":"styles_bg_2__fQQ6h","height":"styles_height__R2M3F"};